import { render, staticRenderFns } from "./ReferrerSignupSuccessful.vue?vue&type=template&id=67908a56&scoped=true"
import script from "./ReferrerSignupSuccessful.vue?vue&type=script&lang=js"
export * from "./ReferrerSignupSuccessful.vue?vue&type=script&lang=js"
import style0 from "./ReferrerSignupSuccessful.vue?vue&type=style&index=0&id=67908a56&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "67908a56",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCardText } from 'vuetify/lib/components/VCard';
import { VForm } from 'vuetify/lib/components/VForm';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCardText,VForm,VRow})
